import { useContext } from 'react';
import { getPlayerChartContext } from './context';
import { useInstanceId } from './useInstanceId';
import type { PlayerChartContextType } from '../types';

export const usePlayerChart = (explicitInstanceId?: string): PlayerChartContextType => {
  const contextInstanceId = useInstanceId();
  const instanceId = explicitInstanceId ?? contextInstanceId;
  
  const PlayerChartContext = getPlayerChartContext(instanceId);
  const context = useContext(PlayerChartContext);
  if (context === undefined) {
    throw new Error(`usePlayerChart must be used within a PlayerChartProvider with instanceId: ${instanceId}`);
  }
  return context;
};